import React from "react";
import { FormattedMessage } from "react-intl";

import Label from "../Label";
import Validation from "../Validation";

import { FormElement, ChangeButton } from "../shared-style";

import messages from "../Select/messages";
import InputSelectCheckbox from "./InputSelectCheckbox";
import { IProps } from "./interfaces";

const SelectCheckbox = <T extends string | number>({
    label,
    value,
    onChange,
    disabled,
    name,
    options,
    changeModal,
    validation,
    lightWithValue,
    join,
    required,
    simulation,
}: IProps<T>) => (
    <FormElement>
        <Label disabled={disabled} required={required}>
            {label}
        </Label>
        {validation && <Validation validation={validation} />}
        {changeModal && (
            <ChangeButton onClick={() => changeModal(name, value)}>
                <FormattedMessage {...messages.modify} />
            </ChangeButton>
        )}
        <InputSelectCheckbox
            value={value}
            onChange={onChange}
            disabled={disabled}
            name={name}
            options={options}
            lightWithValue={lightWithValue}
            join={join}
            simulation={simulation}
        ></InputSelectCheckbox>
    </FormElement>
);

export default SelectCheckbox;
